export function ContentFrame(props: { children: JSX.Element | JSX.Element[], css?: any }) {
    return <div className="ContentFrame" style={props.css}>
        {props.children}
    </div>
}